import AppSnackbar from '../components/molecules/app/AppSnackbar.vue';
import { mountComponent } from './render-component';

const SNACKBAR_LIFETIME = 3000; // Animation is 2200ms, directed by global styles.

export async function showSnackbar(props = {}) {
    const { el, destroy } = mountComponent(
        AppSnackbar,
        {
            props: {
                text: 'Kein Text übergeben',
                ...props,
            },
        },
    );

    document.body.appendChild(el);

    return new Promise((resolve) => {
        setTimeout(() => {
            destroy();
            resolve();
        }, SNACKBAR_LIFETIME);
    });
}
